
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapMutations, mapState } from 'vuex'

import 'vue-slider-component/dist-css/vue-slider-component.css'
import 'vue-slider-component/theme/default.css'
import { mdiMinus, mdiPlus } from '@mdi/js'
import VuetifyMoney from '@/components/ui/VuetifyMoney'
import utils from '@/components/tools/utils'

export default {
  name: 'BiddingAgentExpansionCard',
  components: {
    ValidationObserver,
    ValidationProvider,
    // VueSlider,
    VuetifyMoney
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default: undefined
    }
  },
  icons: { mdiMinus, mdiPlus },
  data: () => ({
    paddingColumn: 'px-2',
    expanded: 0,
    alert: false,
    alertText: 'Ihr Gebot ist zu niedrig',
    submittingDirectBid: false,
    submittingBiddingAgent: false,
    bidValid: true,
    biddingAgentValue: 0,
    showBiddingAgent: false
  }),
  computed: {
    ...mapState('customer', {
      merchantBlocked: state => state.customer?.merchantBlocked
    }),
    auctionId () {
      return this.product.auction.auctionId
    },
    biddingAgentSaveOrConfigureMessage () {
      if (this.product.context?.biddingAgentDto) {
        return this.$t('product.set_bidding_agent_btn', [
          this.formatCurrency(this.biddingAgentValue)
        ])
      } else {
        return this.$t('product.set_bidding_agent_btn_init')
      }
    },
    biddingAgentPrice () {
      return this.formatCurrency(this.product?.context?.biddingAgentDto?.price)
    },
    biddingAgentActive () {
      return (
        this.product.context?.biddingAgentDto?.price >= this.currentPrice &&
        this.product?.auction?.status === 'running' &&
        this.product.context?.holdingHighestBid
      )
    },
    minMaxAllowedBiddingAgentRule () {
      if (this.product.context?.biddingAgentDto?.price) {
        return `min_value:${this.product.context?.biddingAgentDto?.price + this.product.auction.step}|max_value:${this.maxAllowedBiddingAgentPrice}`
      } else if (this.nextBidPrice && this.maxAllowedBiddingAgentPrice) {
        return `min_value:${this.nextBidPrice}|max_value:${this.maxAllowedBiddingAgentPrice}`
      } else {
        return ''
      }
    },

    biddingAgentSliderData () {
      const prices = []

      const step = this.product.auction.step
      let price = this.nextBidPrice
      if (
        this.product.context?.biddingAgentDto &&
        this.product.context?.biddingAgentDto.price > price
      ) {
        price = this.product.context?.biddingAgentDto.price + step
      }

      while (price <= this.maxAllowedBiddingAgentPrice) {
        prices.push({
          id: price,
          name: this.formatCurrency(price)
        })
        price += step
      }

      return prices
    },
    maxAllowedBiddingAgentPrice () {
      if (this.product.context?.biddingAgentDto) {
        return this.product.context?.biddingAgentDto?.maxAllowedPrice
      } else {
        return this.product.auction?.maxAllowedBidPrice
      }
    },
    maxAllowedBidPrice () {
      return this.product.auction?.maxAllowedBidPrice
    },
    minAllowedBiddingAgentPrice () {
      if (this.product.context?.biddingAgentDto) {
        return this.product.context?.biddingAgentDto?.price + this.product?.auction?.step
      } else {
        return this.product?.auction?.currentPrice + this.product?.auction?.step
      }
    },

    currentPrice () {
      return this.product.auction?.currentPrice
    },
    disabledBiddingAgent () {
      if (this.nextBidPrice && this.maxAllowedBiddingAgentPrice) {
        return (
          this.disabled ||
          this.biddingAgentValue < this.nextBidPrice ||
          this.biddingAgentValue > this.maxAllowedBiddingAgentPrice ||
          this.biddingAgentValue < this.minAllowedBiddingAgentPrice ||
          this.merchantBlocked
        )
      } else {
        return true
      }
    },
    nextBidPrice () {
      return this.product.auction?.nextBidPrice
    },
    targetPrice () {
      return this.product.auction?.targetPrice
    },
    isDecrementButtonDisabled () {
      if (this.product.context?.biddingAgentDto) {
        return this.biddingAgentValue - this.product.auction.step <= this.product.context?.biddingAgentDto.price
      } else {
        return (
          this.currentPrice !== null &&
          this.biddingAgentValue - this.product.auction.step <= this.currentPrice
        )
      }
    },
    isIncrementButtonDisabled () {
      return (
        this.maxAllowedBidPrice !== null &&
        this.biddingAgentValue + this.product.auction.step >
        this.maxAllowedBidPrice
      )
    }
  },

  mounted () {
    this.init()
  },
  methods: {
    ...mapActions('product', ['getProduct']),
    ...mapMutations('product', ['setProductAuctionAndContext']),
    init () {
      if (this.currentPrice === this.maxAllowedBidPrice) {
        this.biddingAgentValue = this.currentPrice
      } else {
        this.biddingAgentValue = this.product.auction.nextBidPrice
      }

      if (this.product?.context?.biddingAgentDto) {
        this.biddingAgentValue = Math.max(
          this.product.auction.nextBidPrice,
          this.product.context.biddingAgentDto.price + this.product.auction.step
        )
      }
    },
    async validateBiddingAgent () {
      this.bidValid = await this.$refs.biddingAgentObserver.validate()
    },

    async submitConfigureBidAgent () {
      this.submittingBiddingAgent = true
      this.alert = false
      const postBidData = {
        price: this.biddingAgentValue
      }

      try {
        const { data, status } = await this.$axios.post(
          `/private/auction/bidding-agent/${this.auctionId}`,
          postBidData
        )

        if (status === 200) {
          this.setProductAuctionAndContext(data.product)
        } else if (status === 202 && data.error === 'FIRST_BID_TOO_LOW') {
          this.alertText = this.$t(
            'customer.context.first_bidding_agent_limit_too_low'
          )
          this.alert = true
          await this.getProduct(this.product.entityId)
        }
      } catch (error) {
        this.alertText = 'Sie wurden überboten.'
        this.alert = true
        await this.getProduct(this.product.entityId)
      }
      const step = this.product.auction.step
      this.biddingAgentValue = Number.parseInt(this.biddingAgentValue) + step
      // await this.refreshCallback()
      this.submittingBiddingAgent = false

      try {
        this.$gtm.push({
          event: 'configure_bidding_agent',
          auctionId: this.auctionId,
          productId: this.product.entityId,
          value: this.biddingAgentValue,
          currency: 'EUR',
          transaction_id: this.auctionId + '_' + this.biddingAgentValue
        })
      } catch (e) {
        // console.log(e)
      }
    },
    async biddingAgentInput (event) {
      if (this.nextBidPrice && event >= this.nextBidPrice) {
        this.biddingAgentValue =
          event - (event % 100) + (this.targetPrice % 100)
        await this.validateBiddingAgent()
      } else if (event >= this.targetPrice * 0.5) {
        this.biddingAgentValue =
          event - (event % 100) + (this.targetPrice % 100)

        await this.validateBiddingAgent()
      }
    },
    formatCurrency (value) {
      return utils.formatCurrency(value)
    },
    incrementPrice (step) {
      this.biddingAgentValue += step
    }
  }
}
